<template>
  <div class="footer-container">
    <FooterShareUp></FooterShareUp>

    <FooterWave></FooterWave>

    <FooterProject></FooterProject>

    <FooterEditor
      :text="text"
    >
    </FooterEditor>

    <FooterEnd></FooterEnd>
  </div>
</template>

<script>
import FooterShareUp from '@/components/footer/FooterShareUp.vue';
import FooterWave from '@/components/footer/FooterWave.vue';
import FooterProject from '@/components/footer/FooterProject.vue';
import FooterEditor from '@/components/footer/FooterEditor.vue';
import FooterEnd from '@/components/footer/FooterEnd.vue';

export default {
  props: {
      text: { type: Array },
  },
  components: {
    FooterShareUp,
    FooterWave,
    FooterProject,
    FooterEditor,
    FooterEnd
  }
}
</script>

<style lang="scss" scoped>

</style>